export const environment = {
  production: false,
  // Deployed dev API Gateway base URL.
  // Fill this in after a dev deploy, e.g. https://xxxx.execute-api.us-east-1.amazonaws.com
  apiBaseUrl: "https://yxoce5mp1k.execute-api.us-east-1.amazonaws.com",
  // Supplier portal base URL (S3/CloudFront). Fill in after a dev deploy.
  supplierPortalUrl: "https://SUPPLIER_PORTAL_URL_REPLACE",
  // Dev Cognito admin pool (admin-dev-users) + app client (admin-dev-web).
  cognitoUserPoolId: "us-east-1_TtXFUHlao",
  cognitoClientId: "6cl0f3a2507r1bj8atvnemel5a",
  clarityProjectId: "yb4t33oswz",
};
